import { Component, DoCheck, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "../shared/shared.service";
import { Constants } from "../shared/Helpers/constants";
import { LinkAccountService } from "../_services";
import { Alert, AlertTypeEnum } from "../shared/Helpers/Alert";

@Component({
  moduleId: module.id,
  templateUrl: './link-account-info.component.html'
})

export class LinkAccountInfoComponent implements OnInit, DoCheck {
  public logoPath: any = null;
  public answer: boolean;
  public secret: any;
  public tenant: string;
  public showLinkedText: boolean= false;
  public showDeclinedText: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public sharedService: SharedService,
    public linkedService: LinkAccountService
  ) {
    this.answer = this.activatedRoute.snapshot.paramMap.get('answer').toLowerCase() == 'true';
    this.secret = this.activatedRoute.snapshot.paramMap.get('secret');
    this.tenant = this.activatedRoute.snapshot.paramMap.get('tenant');
  }

  ngOnInit(): void {
    this.linkAccounts()
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

  public navigateToLogin() {
    this.router.navigateByUrl('/login');
  }

  public linkAccounts() {
    if (this.answer == true) {
      this.linkedService.acceptRequest(this.secret, "ACCEPT", this.tenant).subscribe({
        next: (res) => {
          if(res.status === 200) {
            this.showLinkedText = true;
          }
        },
        error: (err) => {
          let msg: string = err?.detailedMessage;
          Alert.basicNotification(AlertTypeEnum.Error, "", msg);
        }
      });
    }
    else if (this.answer == false) {
      this.linkedService.acceptRequest(this.secret, "CANCEL", this.tenant).subscribe({
        next: (res) => {
          if(res.status === 200) {
            this.showDeclinedText = true;
          }
        },
        error: (err) => {
          let msg: string = err?.detailedMessage;
          Alert.basicNotification(AlertTypeEnum.Error, "", msg);
        }
      });
    }
  }
}
